import { CardInfo } from "./card-info.model";

export class SponsoredCard{
    /*
    * 
    */
   constructor(
    public id?: number,
    public displaySorting?: number,
    public active?: boolean,
    public startDateSponsorship?: Date,
    public endDateSponsorship?: Date,
    public photo?: string,
    public link?: string, 
   ){}
}